import { apiFetch } from '../utils/apiBase';

// [W3 契约修复] axios 风格 config.params 支持：RequestInit 没有 params 概念，
// 此前 { params: {...} } 被静默丢弃（如 reseller.ts 的分页参数从未上送）。
function withParams(url: string, config: any): { url: string; init: any } {
    const { params, ...rest } = config || {};
    if (!params || typeof params !== 'object' || Object.keys(params).length === 0) {
        return { url, init: rest };
    }
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
    }
    const query = qs.toString();
    return { url: query ? `${url}${url.includes('?') ? '&' : '?'}${query}` : url, init: rest };
}

const apiClient = {
    get: async <T = any>(url: string, config: any = {}): Promise<{ data: T }> => {
        const { url: u, init } = withParams(url, config);
        const res = await apiFetch(u, { ...init, method: 'GET' });
        return { data: await res.json() };
    },
    post: async <T = any>(url: string, data?: any, config: any = {}): Promise<{ data: T }> => {
        const res = await apiFetch(url, {
            ...config,
            method: 'POST',
            body: data ? JSON.stringify(data) : undefined,
        });
        return { data: await res.json() };
    },
    put: async <T = any>(url: string, data?: any, config: any = {}): Promise<{ data: T }> => {
        const res = await apiFetch(url, {
            ...config,
            method: 'PUT',
            body: data ? JSON.stringify(data) : undefined,
        });
        return { data: await res.json() };
    },
    patch: async <T = any>(url: string, data?: any, config: any = {}): Promise<{ data: T }> => {
        const res = await apiFetch(url, {
            ...config,
            method: 'PATCH',
            body: data ? JSON.stringify(data) : undefined,
        });
        return { data: await res.json() };
    },
    delete: async <T = any>(url: string, config: any = {}): Promise<{ data: T }> => {
        const res = await apiFetch(url, { ...config, method: 'DELETE' });
        return { data: await res.json() };
    }
};

export default apiClient;
